// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65197602","667":"eae0232c","977":"a3caf837"}[chunkId] + ".chunk.js";
};